import React, { useState } from 'react';
import { Grid, IconButton, Button, TextField, InputAdornment, Card, CardContent, CardActions, Link, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { useForm } from "react-hook-form";
import Swal from 'sweetalert2';
import CircularProgress from '@mui/material/CircularProgress';
import {
    postAgregarUsuario
} from 'app/features/Usuarios/usuariosAPI';


const RegistroAltaTitulosEspeciales = () => {
    localStorage.setItem('token', "");
    const { register, handleSubmit } = useForm();

    const onSubmit = data => {
        if (password !== passwordRepetido) {
            return false;
        }


        const lastAtPos = email.lastIndexOf('@');
        const lastDotPos = email.lastIndexOf('.');

        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') === -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
            setErrorEmail("error");
            setTextoErrorEmail("Ingrese un email valido");
            return false;
         }else{
           
            setErrorEmail("");
            setTextoErrorEmail("");
         }

         setErrorDni("");
         setMostrarLoader({ display: ''});
        setMostrarContenido({ display: 'none'});
        const result = postAgregarUsuario({ email: email, password: password, tpoTramite: 9, dni });
        result.then((value) => {
        

           if(value.data.response === undefined)
           {  setTextoErrorEmail("Intentelo nuevamente mas tarde.");
        
           }
            if (!value.data.resultado) {

                if (value.data.codigoError === 0) {

                    setTextoErrorEmail("Intentelo nuevamente mas tarde.");
                }
                if (value.data.codigoError === 1) {

                    setTextoErrorEmail("El email ya se encuentra registrado");
                }
                if (value.data.codigoError === 2) {
                    setTextoErrorEmail("El email aún no se encuentra verificado");
                }
                if (value.data.codigoError === 3) {

                    setTextoErrorEmail("El email no se encuentra registrado");
                }
                if (value.data.codigoError === 8) {
                    Swal.fire({
                        title: 'Estimado/a profesional',
                        html: value.data.message,
                        icon: 'warning',
                        allowOutsideClick: false
                    })
                    setErrorDni("error");
                    setMostrarLoader({ display: 'none'});
                    setMostrarContenido({ display: ''});
                    return false;
                    //setTextoErrorEmail(value.data.message);
                }
                setErrorEmail("error");
            } else {
                Swal.fire({
                    title: 'Estimado/a',
                    html: 'Por favor verifique su correo:<b>' + email + '</b> <br> para poder validarlo.',
                    icon: 'success',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.value) {
                        window.location.href = `/logininscripciontitulosespeciales`;
                    }
                });
            }

            setMostrarLoader({ display: 'none'});
            setMostrarContenido({ display: ''});
        });
    };

    // const PeliculasList = useSelector(selectPeliculas);
    const [email, setEmail] = useState();
    const [errorEmail, setErrorEmail] = useState();
    const [dni, setDni] = useState('');
    const [errorDni, setErrorDni] = useState();
    const [textoErrorEmail, setTextoErrorEmail] = useState();
    const [password, setPassword] = useState();
    const [showPassword, setShowPassword] = useState();
    const [showPasswordRepeat, setShowPasswordRepeat] = useState();
    const [passwordRepetido, setPasswordRepetido] = useState('');
    const [errorPassword, setErrorPassword] = useState();
    const [mostrarLoader, setMostrarLoader] = useState({ display: 'none' });
    const [mostrarContenido, setMostrarContenido] = useState({ display: '' });
    const [errorTextoPassword, setErrorTextoPassword] = useState();
    //    useEffect(()=>{
    //       if(PeliculasList.length === 0)
    //          dispatch(getPeliculasAsync());
    //       return () => {

    //       }
    //    },[PeliculasList]);


    const InputValidatePass = (e) => {
        setPasswordRepetido(e.target.value);

        if (password !== e.target.value) {
            setErrorPassword("error");
            setErrorTextoPassword("Las contraseñas no coinciden");
        } else {

            setErrorPassword("");
            setErrorTextoPassword("");
        }
    }
    const handleClickShowPasswordRepeat = () => {

        setShowPasswordRepeat(!showPasswordRepeat);
    };
    const handleClickShowPassword = () => {

        setShowPassword(!showPassword);
    };

    const onchangeEmail = (e) => {
        setEmail(e.target.value);
    }

    const mascaraDocumento = (evt) => {
        var codigo = evt.which || evt.keyCode;
      
        if (codigo !== 8) {
            var documentoNuevo = "";
            let documento = evt.target.value;

            documento = documento.replace(/\./g, '').replace(/[a-z ]/g, "").split('');

            for (var i = 0; i < documento.length; i++) {

                if (i === 1 || i === 4) {
                    documentoNuevo += documento[i] + ".";
                } else {
                    documentoNuevo += documento[i];
                }

            }

            setDni( documentoNuevo);
        }

    }

    const onchangePassword = (e) => {
   
        
        setPassword(e.target.value);

        if  (passwordRepetido !== "")
        {
         
            if (e.target.value !== passwordRepetido) {
                setErrorPassword("error");
                setErrorTextoPassword("Las contraseñas no coinciden");
            } else {
    
                setErrorPassword("");
                setErrorTextoPassword("");
            }
        }
    }

    return (
        <Grid
        
        align='center'
         direction="column"
    >
        <form onSubmit={handleSubmit(onSubmit)}>
                <Grid md={6} item>
                    <Card>
                        <CardContent >
                            <Typography align='center' variant="h6">Registro</Typography>
                            <Grid sx={{ mb: 3, mt: 2 }} item md={12} xs={12} >
                                <TextField label="Email"
                                    error={errorEmail}
                                    helperText={textoErrorEmail}
                                    value={email}
                                    {...register("email")}
                                    onChange={(value) => onchangeEmail(value)}
                                    required
                                    variant="outlined"
                                    fullWidth
                                    type="email"
                                    inputProps={{ sx: {fontWeight: 'light'}}}
                                    InputLabelProps={{ sx: { fontWeight: 'light', color: 'gray' }}}
                                />

                            </Grid>
                            <Grid sx={{ mb: 3, mt: 2 }} item md={12} xs={12} >
                                <TextField label="DNI"
                                    error={errorDni}
                                    value={dni}
                                    {...register("dni")}
                                    onChange={(value) => mascaraDocumento(value)}
                                    inputProps={{ maxLength: 10, sx: {fontWeight: 'light'}}}
                                    required
                                    variant="outlined"
                                    fullWidth
                                    type="text"
                                    InputLabelProps={{ sx: { fontWeight: 'light', color: 'gray' }}}
                                />

                            </Grid>

                            <Grid item sx={{ mb: 3 }} md={12} xs={12}  >
                                <TextField label="Contraseña"
                                    value={password}
                                    type={showPassword ? "text" : "password"}
                                    {...register("password")}
                                    InputProps={{
                                        endAdornment:
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleClickShowPassword}
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>

                                    }}
                                    onChange={(value) => onchangePassword(value)}
                                    required
                                    variant="outlined"
                                    InputLabelProps={{ sx: { fontWeight: 'light', color: 'gray' }}}
                                    inputProps={{ sx: { fontWeight: 'light' }}}
                                    fullWidth
                                />
                            </Grid>
                            <Grid sx={{ mb: 3 }} item md={12} xs={12} >
                                <TextField
                                    type={showPasswordRepeat ? "text" : "password"}
                                    InputProps={{
                                        endAdornment:
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleClickShowPasswordRepeat}
                                                >
                                                    {showPasswordRepeat ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>

                                    }}
                                    value={passwordRepetido}
                                    label=" Repetir Contraseña"
                                    onChange={(value) => InputValidatePass(value)}
                                    error={errorPassword}
                                    helperText={errorTextoPassword}
                                    required variant="outlined"
                                    fullWidth
                                    InputLabelProps={{ sx: { fontWeight: 'light', color: 'gray' }}}
                                    inputProps={{ sx: { fontWeight: 'light' }}}
                                />

                            </Grid>

                            <CardActions
                                sx={{
                                    justifyContent: "center",
                                }}>

                                <Button startIcon={<AddIcon />}  style={mostrarContenido} variant="contained" type="submit" color="primary" >
                                    Registrarse
                                </Button>
                                <Button style={mostrarLoader}  variant="contained"  color="primary" >
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            color: "white"
                                        }}
                                    />
                                </Button>

                            </CardActions>
                            <Grid item sx={{ mt: 2 }} md={12} xs={12} className="centrar_contenido"  >
                                <Grid className="centrar_contenido">
                                    Si ya tienes una cuenta.
                                    <Link href="/logininscripciontitulosespeciales">
                                        Inicia Sesión
                                    </Link>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
        </form>
        </Grid>
    )
}

export default RegistroAltaTitulosEspeciales;
